// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cMD8M","buttons":"styles_buttons__2T-UQ"};